import { Button } from '@creditornot/cb-button';
import { FormRow } from '@creditornot/cb-form';
import { cssThemedValue } from '@creditornot/cb-ingredients';
import { Input } from '@creditornot/cb-input';
import { ModalContent, ModalFooter, ModalHeader } from '@creditornot/cb-modal';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import styled from 'styled-components';

import { WoltModal, APIErrorNotification } from 'common/components';

type Props = {
  isLoading: boolean;
  error?: any;
  initialName: string;
  onConfirm: (name: string) => void;
  onClose: () => void;
};

const Root = styled.form``;

const StyledModal = styled(WoltModal)`
  background-color: ${cssThemedValue('surfaceMain')};
  border-radius: 8px;
`;

const StyledModalContent = styled(ModalContent)`
  padding: 0 24px;
`;

const StyledInput = styled(Input)`
  width: 392px;
`;

const StyledModalFooter = styled(ModalFooter)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
`;

const ActionsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const EditAreaModal = ({ isLoading, error, initialName, onConfirm, onClose }: Props) => {
  const intl = useIntl();
  const [inputValue, setInputValue] = useState(initialName);
  const isConfirmButtonDisabled = isLoading || inputValue === initialName;
  return (
    <Root
      onKeyPress={event => {
        if (event.key === 'Enter' && !isConfirmButtonDisabled) {
          onConfirm(inputValue);
        }
      }}
    >
      <StyledModal isOpen onRequestClose={onClose}>
        <ModalHeader onCloseClick={onClose}>
          <FormattedMessage id="picking-route.modal-edit-title" />
        </ModalHeader>
        <StyledModalContent>
          <FormRow label={intl.formatMessage({ id: 'picking-route.area-name' })} labelAlign="center">
            <StyledInput autoFocus value={inputValue} onChange={e => setInputValue(e.currentTarget.value)} />
          </FormRow>
        </StyledModalContent>
        <StyledModalFooter>
          <ActionsContainer>
            <Button variant="lightBlue" size="small" onClick={onClose} disabled={isLoading}>
              <FormattedMessage id="state.cancel" />
            </Button>
            <Button
              variant="blue"
              size="small"
              style={{ marginInlineStart: 18 }}
              onClick={() => onConfirm(inputValue)}
              disabled={isConfirmButtonDisabled}
              loading={isLoading}
            >
              <FormattedMessage id="state.save" />
            </Button>
          </ActionsContainer>
          {error && <APIErrorNotification error={error} style={{ marginBlockStart: 18 }} />}
        </StyledModalFooter>
      </StyledModal>
    </Root>
  );
};

export default EditAreaModal;
